<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link collapse" to="/">
        <!-- <img v-if="logo" :src="logo" class="sidebar-logo"> -->
        <!-- <svg-icon class="sidebar-logo" icon-class="logo" /> -->
        <h1 class="sidebar-title">{{ title }} </h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <!-- <svg-icon class="sidebar-logo" icon-class="logo" /> -->
        <!-- <h1 class="sidebar-title">{{ title }} </h1> -->
      </router-link>
    </transition>
  </div>
</template>

<script>
import Logo from '@/assets/images/logo.png'
import { mapState } from 'vuex'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState({
      title: state => state.settings.title
    })
  },
  data() {
    return {
      logo: Logo
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 64px;
  line-height: 80px;
  text-align: center;
  overflow: hidden;
  color:#0d6efd;
  fill: #0d6efd;
  border-bottom: 1px solid #e4e4e4;
  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 180px;
      padding-top: 13px;  
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #0d6efd;
      font-weight: 600;
      line-height: 50px;
      font-size: 24px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
      padding-bottom: 10px;
    }
  }

  &.collapse {
    height: 64px;
    line-height: 25px;
    padding-top: 10px;
    .sidebar-logo {
      width: 32px;
      height: 32px;
      margin: 0 auto !important;
    }
    .sidebar-title{
      padding: 0 10px;
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
